<template>
  <div class="splashScreen">
          <v-container class="landingContainer">
            <v-row  align="center" justify="center">
              <v-col  class=" mt-5 mb-5" cols=6>
                        <v-img :src="require('@/assets/MEMEX-logo.svg')"></v-img>
              </v-col>
            </v-row>

            <v-row align="center" justify="center">
              <v-col class=" mb-0 pb-0" align="center" justify="center" cols=12>
                <span class="landingSubTitle">Storytelling through</span>
              </v-col>
              <v-col class="mt-0 pt-0 " align="center" justify="center" cols=12>
                <span class="landingSubTitle">memories and experiences</span>
              </v-col>
            </v-row>
            <v-row>
              <v-img class="splashscreen" :src="require('@/assets/splash.png')"/>
            </v-row>
          </v-container>

  </div>
</template>

<script>
  export default {
    name: 'splashScreen',
    data() {
      return {
        interval: null
      }

    },
    computed: {
        termsandcondition: {
      get: function() {
        return this.$store.state.isTermsAndCondition
      }
    }
    },
    mounted() {
      this.interval = setTimeout(
        function () {
          if(this.termsandcondition==true){
          this.$router.push({
            path: "/loginFirstTime"
          });
          }
          else{
                      this.$router.push({
            path: "/termsAndConditions"
          });
          }
        }.bind(this),
        5000
      );
    },
    methods: {
      gotopage: function (page) {
        this.$router.push(page)
      }
    }
  }
</script>
<style scoped>
.splashscreen{
width: 100%;
height: 60%;
position: absolute;
bottom: 0px;
}
@media only screen and (max-width: 400px) {
.splashscreen{
height: 64%;
}
}
</style>